document.addEventListener("DOMContentLoaded", () => {
  const menuButton = document.querySelector(".menu-button");
  const navigation = document.querySelector(".nav-links");
  if (menuButton && navigation) {
    menuButton.addEventListener("click", () => {
      const open = navigation.classList.toggle("is-open");
      menuButton.setAttribute("aria-expanded", String(open));
    });
  }

  const money = (cents, currency) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency || "USD" }).format(amount);
    } catch (error) {
      return `$${amount.toFixed(2)}`;
    }
  };

  document.querySelectorAll("[data-product-card]").forEach((card) => {
    const image = card.querySelector(".product-image-primary");
    const links = card.querySelectorAll("[data-card-link], [data-card-title-link]");
    const price = card.querySelector("[data-card-price]");
    const compare = card.querySelector("[data-card-compare]");
    const discount = card.querySelector("[data-card-discount]");
    const currency = card.dataset.currency || "USD";
    card.querySelectorAll("[data-card-swatch]").forEach((swatch) => {
      swatch.addEventListener("click", () => {
        card.querySelectorAll("[data-card-swatch]").forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle("is-selected", selected);
          item.setAttribute("aria-pressed", String(selected));
        });
        if (image && swatch.dataset.imageSrc) image.src = swatch.dataset.imageSrc;
        links.forEach((link) => { if (swatch.dataset.variantUrl) link.href = swatch.dataset.variantUrl; });
        const current = Number(swatch.dataset.price || 0);
        const original = Number(swatch.dataset.comparePrice || 0);
        const sale = original > current;
        if (price) price.textContent = money(current, currency);
        if (compare) {
          compare.hidden = !sale;
          compare.textContent = sale ? money(original, currency) : "";
        }
        if (discount) {
          discount.hidden = !sale;
          discount.textContent = sale ? `-${Math.round(((original - current) / original) * 100)}%` : "";
        }
      });
    });
  });

  document.querySelectorAll("[data-sav-product]").forEach((section) => {
    const variantData = section.querySelector("[data-product-variants]");
    if (!variantData) return;
    let variants;
    try { variants = JSON.parse(variantData.textContent); } catch (error) { return; }

    const inputs = Array.from(section.querySelectorAll(".sav-option-input"));
    const groups = Array.from(section.querySelectorAll("[data-option-group]"));
    const variantId = section.querySelector("[data-variant-id]");
    const addButton = section.querySelector("[data-add-to-cart]");
    const price = section.querySelector("[data-product-price]");
    const compare = section.querySelector("[data-product-compare-price]");
    const discount = section.querySelector("[data-product-discount]");
    const status = section.querySelector("[data-variant-status]");
    const currency = section.dataset.currency || "USD";

    const selectedOptions = () => {
      const selected = [];
      groups.forEach((group) => {
        const input = group.querySelector(".sav-option-input:checked");
        if (input) selected[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return selected;
    };
    const exactVariant = () => {
      const selected = selectedOptions();
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    };
    const selectVariant = (variant) => {
      variant.options.forEach((value, index) => {
        const input = inputs.find((item) => Number(item.dataset.optionPosition) === index + 1 && item.value === value);
        if (input) input.checked = true;
      });
    };
    const requirementsBefore = (group) => groups.slice(0, groups.indexOf(group)).map((item) => {
      const input = item.querySelector(".sav-option-input:checked");
      return input ? { position: Number(input.dataset.optionPosition) - 1, value: input.value } : null;
    }).filter(Boolean);
    const updateLabels = () => groups.forEach((group) => {
      const input = group.querySelector(".sav-option-input:checked");
      const output = group.querySelector("[data-selected-option]");
      const label = input ? group.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      if (output && label) output.textContent = label.textContent.trim();
    });
    const updateAvailability = () => inputs.forEach((input) => {
      const group = input.closest("[data-option-group]");
      const position = Number(input.dataset.optionPosition) - 1;
      const required = requirementsBefore(group);
      const available = variants.some((variant) => variant.available && variant.options[position] === input.value && required.every((item) => variant.options[item.position] === item.value));
      input.disabled = !available;
      const label = section.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (label) label.classList.toggle("is-unavailable", !available);
    });
    const updateProduct = (variant) => {
      const available = Boolean(variant && variant.available);
      if (variantId) variantId.value = variant ? variant.id : "";
      if (price && variant) price.textContent = money(variant.price, currency);
      const original = Number(variant?.compare_at_price || 0);
      const current = Number(variant?.price || 0);
      const sale = original > current;
      if (compare) { compare.hidden = !sale; compare.textContent = sale ? money(original, currency) : ""; }
      if (discount) { discount.hidden = !sale; discount.textContent = sale ? `-${Math.round(((original - current) / original) * 100)}%` : ""; }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = !variant ? section.dataset.labelUnavailable : available ? section.dataset.labelAdd : section.dataset.labelSoldOut;
      }
      if (status) status.textContent = variant ? "" : section.dataset.labelUnavailable;
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      if (mediaId) {
        const target = section.querySelector(`[data-media-id="${CSS.escape(String(mediaId))}"]`);
        if (target) {
          section.querySelectorAll("[data-media-id]").forEach((item) => item.classList.toggle("is-selected", item === target));
          if (window.matchMedia("(max-width: 800px)").matches) target.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      }
      if (variant) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);
      }
    };

    inputs.forEach((input) => input.addEventListener("change", () => {
      let variant = exactVariant();
      if (!variant) {
        const group = input.closest("[data-option-group]");
        const required = requirementsBefore(group);
        const position = Number(input.dataset.optionPosition) - 1;
        variant = variants.find((candidate) => candidate.available && candidate.options[position] === input.value && required.every((item) => candidate.options[item.position] === item.value));
        if (variant) selectVariant(variant);
      }
      updateLabels();
      updateAvailability();
      updateProduct(variant || exactVariant());
    }));

    const initial = exactVariant() || variants.find((variant) => variant.available);
    if (initial) selectVariant(initial);
    updateLabels();
    updateAvailability();
    updateProduct(initial);
  });
});
